export default ({ width = 40, height = 40 }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="40" height="40" rx="8" fill="#E5E7EB" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 9.69844C8 8.76042 8.76042 8 9.69844 8H30.3011C31.2392 8 31.9996 8.76042 31.9996 9.69844V26.8672C31.9996 27.1731 31.7516 27.4211 31.4457 27.4211C31.1398 27.4211 30.8919 27.1731 30.8919 26.8672V9.69844C30.8919 9.37218 30.6274 9.1077 30.3011 9.1077H9.69844C9.37218 9.1077 9.1077 9.37218 9.1077 9.69844V25.7226C9.1077 26.0489 9.37218 26.3134 9.69844 26.3134H13.1322C13.4381 26.3134 13.6861 26.5613 13.6861 26.8672C13.6861 27.1731 13.4381 27.4211 13.1322 27.4211H9.69844C8.76042 27.4211 8 26.6607 8 25.7226V9.69844ZM17.1567 26.8672C17.1567 26.5613 17.4047 26.3134 17.7106 26.3134H22.289C22.5949 26.3134 22.8428 26.5613 22.8428 26.8672C22.8428 27.1731 22.5949 27.4211 22.289 27.4211H17.7106C17.4047 27.4211 17.1567 27.1731 17.1567 26.8672Z"
      fill="#1F2A37"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.7356 21.145C21.7356 20.8391 21.9835 20.5912 22.2894 20.5912H31.4461C31.752 20.5912 32 20.8391 32 21.145V30.3017C32 31.2397 31.2396 32.0001 30.3016 32.0001H23.434C22.496 32.0001 21.7356 31.2397 21.7356 30.3017V25.7234C21.7356 25.4175 21.9835 25.1695 22.2894 25.1695C22.5953 25.1695 22.8432 25.4175 22.8432 25.7234V30.3017C22.8432 30.6279 23.1077 30.8924 23.434 30.8924H30.3016C30.6278 30.8924 30.8923 30.6279 30.8923 30.3017V21.6989H22.8432V22.2896C22.8432 22.5955 22.5953 22.8434 22.2894 22.8434C21.9835 22.8434 21.7356 22.5955 21.7356 22.2896V21.145Z"
      fill="#1F2A37"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.7357 8.55394C21.7357 8.24806 21.9837 8.00009 22.2895 8.00009L30.3011 8C31.2392 8 31.9996 8.76042 31.9996 9.69844L32 21.145C32 21.4509 31.7522 21.6982 31.4463 21.6982H22.2895C21.9837 21.6982 21.7356 21.4509 21.7356 21.145L21.7357 19.9998C21.7357 19.6939 21.9837 19.446 22.2895 19.446C22.5954 19.446 22.8434 19.6939 22.8434 19.9998V20.5905H30.8924L30.8919 9.69844C30.8919 9.37218 30.6274 9.1077 30.3011 9.1077L22.8434 9.10779V16.566C22.8434 16.8719 22.5954 17.1199 22.2895 17.1199C21.9837 17.1199 21.7357 16.8719 21.7357 16.566V8.55394Z"
      fill="#1F2A37"
    />
  </svg>
);
